import { Link } from "react-router-dom";
import { useBrandingAssets } from "@/hooks/useBrandingAssets";

export function Footer() {
  const { footerLogoUrl } = useBrandingAssets();
  return (
    <footer
      data-app-footer
      className="bg-footer border-t border-footer-border py-8 text-footer-muted"
    >
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src={footerLogoUrl}
                alt="PayStreem"
                className="h-28 w-auto"
                width="199"
                height="112"
                loading="lazy"
              />
            </Link>
            <p className="text-sm">
              Connecting artists with sponsors through innovative music
              streaming.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-footer-foreground mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-primary-light transition">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/charts"
                  className="hover:text-primary-light transition"
                >
                  Charts
                </Link>
              </li>
              <li>
                <Link
                  to="/profiles"
                  className="hover:text-primary-light transition"
                >
                  Discover
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-footer-foreground mb-4">
              Resources
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/about"
                  className="hover:text-primary-light transition"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-primary-light transition">
                  FAQ
                </Link>
              </li>
              <li>
                <Link
                  to="/support"
                  className="hover:text-primary-light transition"
                >
                  Support
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.paystreem.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-primary-light transition"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-footer-foreground mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/terms"
                  className="hover:text-primary-light transition"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="hover:text-primary-light transition"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/copyright"
                  className="hover:text-primary-light transition"
                >
                  Copyright Info
                </Link>
              </li>
              <li>
                <Link
                  to="/aml-policy"
                  className="hover:text-primary-light transition"
                >
                  AML Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-footer-border mt-8 pt-6 text-center text-xs">
          <p>
            &copy; {new Date().getFullYear()} PayStreem. All rights reserved.
            Powered By Giant Beats® Technologies.
          </p>
        </div>
      </div>
    </footer>
  );
}
